'use client';

import { CSSProperties, ReactNode, useEffect, useRef, useState } from 'react';

import { useInView } from '@/hooks/use-in-view';

type Props = { children: ReactNode; className?: string; style?: CSSProperties; delayMs?: number };

/**
 * Plays an AI-tab style scene once it is in view: sets `data-state="in"`, the attribute the
 * illustration parts animate on (AiInDesignTabs/illustrations/parts). Until then, and without JS,
 * the scene shows its end state.
 */
export const SceneTrigger = ({ children, className, style, delayMs = 0 }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { rootMargin: '0px 0px -20% 0px' });
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    if (!inView) return;
    const timer = window.setTimeout(() => setPlaying(true), delayMs);
    return () => window.clearTimeout(timer);
  }, [inView, delayMs]);

  return (
    <div ref={ref} className={className} style={style} data-state={playing ? 'in' : undefined}>
      {children}
    </div>
  );
};
